import { View, SxProp } from "dripsy";

import React from "react";

interface TransactionsProps {
  isLoading: boolean;
  subscribedTransactions: Array<any>;
  redeemedTransactions: Array<any>;
  rewardedTransactions: Array<any>;
}

export const Transactions: React.FC<TransactionsProps> = (props) => {
  const {
    isLoading,
    subscribedTransactions,
    redeemedTransactions,
    rewardedTransactions,
  } = props;

  return <View sx={styles.container}></View>;
};

enum StyleName {
  container = "container",
}

const styles: Record<StyleName, SxProp> = {
  container: {},
};
